<template>
    <v-row>
        <v-col cols="8" class="table-head pa-0 ma-0">
            <v-row no-gutters>
                <v-col cols="12" class="buttom-border table-head">
                    <v-row no-gutters class="top-border">
                        <v-col cols="6">
                            <v-row no-gutters>
                                <v-col cols="12" class="text-center table-head primary--text">Nombre</v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="6">
                            <v-row no-gutters>
                                <v-col cols="12" class="text-center left-border primary--text">Prefijo</v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters v-for="type_number_serie in Object.keys(aux_number_series)" :key="aux_number_series[type_number_serie]">
                <v-col cols="6" class="buttom-border">
                    <v-row no-gutters>
                        <v-col cols="12" class="text-center align-self-end table-row">
                            <doc-text-field 
                                :value="changeToLabel(type_number_serie)" 
                                dense 
                                hide-details 
                                kind="text" 
                                :readonly="true"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="6" class="buttom-border">
                    <v-row no-gutters>
                        <v-col  cols="12" class="table-row">
                            <doc-text-field 
                                v-model="number_series[type_number_serie]" 
                                dense 
                                hide-details 
                                kind="text" 
                                @input="updateNumberSeries"
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import DocTextField from './DocTextField.vue';
import { mapFields } from 'vuex-map-fields';

export default {
    name: 'NumberSeriesValuesTable',
    components: {
        DocTextField
    },
    data() {
        return {
            aux_number_series: {},
        };
    },
    props: {
        number_series: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapFields('connector', {
            number_series_labels: 'number_series_labels', 
        }),
    },
    mounted() {
        this.aux_number_series = JSON.parse(JSON.stringify(this.number_series));
    },
    methods:{
        updateNumberSeries() {
            this.$emit('update-number-series', this.aux_number_series);
        },
        changeToLabel(text){
            switch(text){
                case "supplier_prefix":
                    return "Prefijo de proveedor"
                case "customer_prefix":
                    return "Prefijo de cliente"
            }
        }
    }
}
</script>

<style scoped>
    .buttom-border {
      border-bottom-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .top-border {
      border-top-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .left-border {
      border-left-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .right-border {
      border-right-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin; 
    }
    .table-head {
        border-left-style:solid;
        border-right-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-row{
        border-left-style:solid;
        border-right-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .title-color {
        color:var(--v-primary-base);
    }
    .dragging_file{
      background: var(--v-neutralDark-base)!important;
      border-radius: 5px;
      border: 2px dashed #ccc;
    }

    .primary-bckground {
      background-color: var(--v-primary-base);
    }
    .primary-border {
      border-color: var(--v-primary-base) !important;
    }
    .table-row >>> div > .v-input {
      margin-top: 0px;
    }
    .table-row >>> div > .v-input > .v-input__control > .v-input__slot {
      padding-bottom: 4px;
    }
    .progress-circular {
      margin: 7%;
    }
</style>
